/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerRef,
  CashDrawerRefOptional,
  CashDrawerRefMetaI,
  CashDrawerRefTrackedI,
} from "./cash-drawer-ref";
import { CashDrawerRefTracked, CashDrawerRefMeta } from "./cash-drawer-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterBase,
  PrinterBaseOptional,
  PrinterBaseMetaI,
  PrinterBaseTrackedI,
} from "./printer-base";
import { PrinterBaseTracked, PrinterBaseMeta } from "./printer-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterRef,
  PrinterRefOptional,
  PrinterRefMetaI,
  PrinterRefTrackedI,
} from "./printer-ref";
import { PrinterRefTracked, PrinterRefMeta } from "./printer-ref";

/**
 *
 * @export
 * @interface PrinterFull
 */
export interface PrinterFullOptional extends DeletableOptional {
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerMAC?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerName?: string;
  /**
   *
   * @type {boolean}
   * @memberof PrinterFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterFull
   */
  isNew?: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof PrinterFull
   */
  cashDrawer?: CashDrawerRefOptional;
}

export interface PrinterFull
  extends PrinterFullOptional, Deletable, PrinterBase, PrinterRef {
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerMAC: string;
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerName?: string;
  /**
   *
   * @type {boolean}
   * @memberof PrinterFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterFull
   */
  isNew?: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof PrinterFull
   */
  cashDrawer?: CashDrawerRef;
}

export interface PrinterFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerMAC?: string;
  printerMACIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerUser?: string;
  printerUserIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterFull
   */
  printerName?: string;
  printerNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof PrinterFull
   */
  cashDrawer?: CashDrawerRefTrackedI;
  cashDrawerIsSet: boolean;
}

transformDatesMap.set("PrinterFull", function (model: PrinterFull) {
  const transformDatescashDrawer = transformDatesMap.get("CashDrawerRef");
  if (transformDatescashDrawer && model.cashDrawer) {
    transformDatescashDrawer(model.cashDrawer);
  }
});

export type PrinterFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  printerMAC: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerUser: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  cashDrawer: PropertyMeta<CashDrawerRefMetaI>;
}>;

export var PrinterFullMeta: PrinterFullMetaI = {} as PrinterFullMetaI;
PrinterFullMeta = typeMeta("PrinterFull", {
  printerMAC: propertyMeta(
    "printerMAC",
    false,
    true,
    true,
    MetaTypesBase.string,
  ),
  printerUser: propertyMeta(
    "printerUser",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  printerName: propertyMeta(
    "printerName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  cashDrawer: propertyMeta(
    "cashDrawer",
    false,
    false,
    false,
    CashDrawerRefMeta,
  ),
});

const metaI = PrinterFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PrinterRefMeta]);
  metaI.printerMAC.inheritedFrom = PrinterRefMeta.printerMAC;
  metaI.interfaces = metaI.interfaces.concat([PrinterBaseMeta]);
  metaI.printerUser.inheritedFrom = PrinterBaseMeta.printerUser;
  metaI.printerName.inheritedFrom = PrinterBaseMeta.printerName;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class PrinterFullTracked
  extends DeletableTracked
  implements PrinterFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  printerMAC__I?: string = undefined;

  get printerMACIsSet() {
    return this.printerMAC !== undefined;
  }
  set printerMACIsSet(v: boolean) {}
  set printerMAC(v: undefined | string) {
    if (v !== undefined) {
      this.printerMAC__I = v;
      this.printerMACIsSet = true;
    } else {
      this.printerMAC__I = v || undefined;
      this.printerMACIsSet = true;
    }
    this.changeTracker = true;
  }
  get printerMAC() {
    return this.printerMAC__I;
  }
  printerUser__I?: string = undefined;
  printerUserIsSet: boolean = false;
  set printerUser(v: undefined | string) {
    if (v !== undefined) {
      this.printerUser__I = v;
      this.printerUserIsSet = true;
    } else {
      this.printerUser__I = v || undefined;
      this.printerUserIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerUser() {
    return this.printerUser__I;
  }
  printerName__I?: string = undefined;
  printerNameIsSet: boolean = false;
  set printerName(v: undefined | string) {
    if (v !== undefined) {
      this.printerName__I = v;
      this.printerNameIsSet = true;
    } else {
      this.printerName__I = v || undefined;
      this.printerNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerName() {
    return this.printerName__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  cashDrawer__I?: CashDrawerRefTracked = undefined;
  cashDrawerIsSet: boolean = false;
  set cashDrawer(v: undefined | CashDrawerRefTracked) {
    if (v !== undefined) {
      this.cashDrawer__I = v;
      this.cashDrawerIsSet = true;
    } else {
      this.cashDrawer__I = v || undefined;
      this.cashDrawerIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawer() {
    return this.cashDrawer__I;
  }
  constructor(config?: PrinterFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.printerMACIsSet == true && other?.printerMACIsSet == true)
      return this.printerMAC == other.printerMAC;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.printerMAC) {
      this.printerMACIsSet = true;
    }

    this.cashDrawer?.setIds();
  }
  assignFrom(
    config: PrinterFullOptional,
    options?: AssignOptions,
  ): PrinterFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.printerMAC &&
      this.printerMACApplyFilter(optionsRequired.filter)
    ) {
      this.printerMAC = config.printerMAC;
      if (optionsRequired.unassign) this.printerMACIsSet = false;
      else this.printerMACIsSet = true;
    }
    if (
      config.printerUser &&
      this.printerUserApplyFilter(optionsRequired.filter)
    ) {
      this.printerUser = config.printerUser;
      if (optionsRequired.unassign) this.printerUserIsSet = false;
      else this.printerUserIsSet = true;
    }
    if (
      config.printerName &&
      this.printerNameApplyFilter(optionsRequired.filter)
    ) {
      this.printerName = config.printerName;
      if (optionsRequired.unassign) this.printerNameIsSet = false;
      else this.printerNameIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.cashDrawer &&
      this.cashDrawerApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawer = new CashDrawerRefTracked(config.cashDrawer, options);
      if (optionsRequired.unassign) this.cashDrawerIsSet = false;
      else this.cashDrawerIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PrinterFullTrackedI {
    const cloned = {} as PrinterFullTrackedI;
    if (
      this.printerMACIsSetDeep() &&
      this.printerMACApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerMACIsSet = true;
      cloned.printerMAC = this.printerMAC;
    } else {
      //cloned.printerMACIsSet = false
    }
    if (
      this.printerUserIsSetDeep() &&
      this.printerUserApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerUserIsSet = true;
      cloned.printerUser = this.printerUser;
    } else {
      //cloned.printerUserIsSet = false
    }
    if (
      this.printerNameIsSetDeep() &&
      this.printerNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerNameIsSet = true;
      cloned.printerName = this.printerName;
    } else {
      //cloned.printerNameIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.cashDrawerIsSetDeep() &&
      this.cashDrawerApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerIsSet = true;
      cloned.cashDrawer = this.cashDrawer?.removeUnset(filter);
    } else {
      //cloned.cashDrawerIsSet = false
    }
    if (!isDeleted(this) && !this.printerMACIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PrinterFullTrackedI {
    if (!this.printerMACApplyFilter(filter)) this.printerMACIsSet = false;

    if (!this.printerUserApplyFilter(filter)) this.printerUserIsSet = false;

    if (!this.printerNameApplyFilter(filter)) this.printerNameIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.cashDrawerApplyFilter(filter)) this.cashDrawerIsSet = false;
    this.cashDrawer?.unassignAll(filter);

    return this;
  }
  printerMACApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterFullMeta.printerMAC,
      PrinterFullMeta,
      this.printerMAC,
      this,
    );
  }
  printerMACIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerMACIsSet && this.printerMACApplyFilter(filter)) return true;

    return false;
  }
  printerUserApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterFullMeta.printerUser,
      PrinterFullMeta,
      this.printerUser,
      this,
    );
  }
  printerUserIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerUserIsSet && this.printerUserApplyFilter(filter))
      return true;

    return false;
  }
  printerNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterFullMeta.printerName,
      PrinterFullMeta,
      this.printerName,
      this,
    );
  }
  printerNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerNameIsSet && this.printerNameApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterFullMeta.isDeleted,
      PrinterFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PrinterFullMeta.isNew, PrinterFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  cashDrawerApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterFullMeta.cashDrawer,
      PrinterFullMeta,
      this.cashDrawer,
      this,
    );
  }
  cashDrawerIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerIsSet && this.cashDrawerApplyFilter(filter)) return true;
    return this.cashDrawer?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.printerMACIsSetDeep(filter)) return true;
    if (this.printerUserIsSetDeep(filter)) return true;
    if (this.printerNameIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.cashDrawerIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
